import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const useSingleOptionAsFormDefault = (
  id: string,
  options: SelectOption[] | undefined
) => {
  const { setValue } = useFormContext();
  useEffect(() => {
    if (options?.length === 1) {
      setValue(id, options[0]);
    }
  }, [setValue, options, id]);
};

export default useSingleOptionAsFormDefault;
